import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { PatchNotesService } from '../services';
import PatchNotesGetters from './getters';
import PatchNotesMutations from './mutations';
import PatchNotesState from './state';

const patchNotesService = new PatchNotesService();

export default class PatchNotesActions extends Actions<
  PatchNotesState,
  PatchNotesGetters,
  PatchNotesMutations,
  // eslint-disable-next-line no-use-before-define
  PatchNotesActions
> {
  async get_patchnotes() {
    try {
      const { current_page } = this.state.pagination_props;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: 5,
          page: current_page,
        },
      };

      const { data, meta } = await patchNotesService.get_patchnotes(payload);

      this.mutations.SET_PATCH_NOTES(data.items);

      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    }
  }
}
